export const TYPE_OF_APPOINTMENTS = [
    {
        label: "Review",
        value: "Review",
    },
    {
        label: "Blood",
        value: "Blood",
    },
    {
        label: "Day 3",
        value: "Day 3",
    },
    {
        label: "Blood and Ultrasound",
        value: "Blood and Ultrasound",
    },
    {
        label: "Biopsy",
        value: "Biopsy",
    },
    {
        label: "IVF Coordination",
        value: "IVF Coordination",
    },
    {
        label: "Pelvic",
        value: "Pelvic",
    },
    {
        label: "3D Pelvic",
        value: "3D Pelvic",
    },
    {
        label: "Sperm Freezing",
        value: "Sperm Freezing",
    },
    {
        label: "Semen Analysis",
        value: "Semen Analysis",
    },
    {
        label: "Embryologist",
        value: "Embryologist",
    },
    {
        label: "DNA Fragmentation",
        value: "DNA Fragmentation",
    },
    {
        label: "Sono",
        value: "Sono",
    },
    {
        label: "Dye Test",
        value: "Dye Test",
    },
    {
        label: "TDI ",
        value: "TDI ",
    },
    {
        label: "Scrotal",
        value: "Scrotal",
    },
    {
        label: "Swab",
        value: "Swab",
    },
    {
        label: "Counselling",
        value: "Counselling",
    },
    {
        label: "IUI",
        value: "IUI",
    },
    {
        label: "Early OB",
        value: "Early OB",
    },
];

export const PREFERRED_CLINIC = [
    {
        label: "Concord",
        value: "Concord",
    },
    {
        label: "Milton",
        value: "Milton",
    },
    {
        label: "Richmond Hill",
        value: "Richmond Hill",
    },
    {
        label: "Burlington",
        value: "Burlington",
    },
    {
        label: "Brampton ",
        value: "Brampton ",
    },
    {
        label: "Mississauga",
        value: "Mississauga",
    },
    {
        label: "Scarborough",
        value: "Scarborough",
    },

    {
        label: "Hamilton",
        value: "Hamilton",
    },
    {
        label: "Kitchener",
        value: "Kitchener",
    },
    {
        label: "North York",
        value: "North York",
    },
    {
        label: "Oakville",
        value: "Oakville",
    },
    {
        label: "Toronto",
        value: "Toronto",
    },
];


export const WEB_SOCKET_URI = "wss://cycles.nlf.clinic:3280/echo";
